import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledTermsConditions = styled.svg<IconProps>`
  & .cls-1 {
    fill: none;
  }

  & .cls-2 {
    fill: var(--chatbot-color-primary, #404040);
  }
`;

const TermsConditionsIcon: React.FC<IconProps> = props => {
  const activeclass = props.active ? 'active' : undefined;
  return (
    <StyledTermsConditions
      id='TermsConditions-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeclass}
    >
      <g id='Privacy_Icon' data-name='Privacy Icon' transform='translate(16 16)'>
        <g id='Group_13695' data-name='Group 13695' transform='translate(-16 -16)'>
          <rect id='Margin' className='cls-1' width='32' height='32' />
          <path
            id='Path_11091'
            data-name='Path 11091'
            className='cls-2'
            d='M16.464,25.16a9.771,9.771,0,0,1-6.976-9.4V11.1L16.464,8l6.977,3.1v4.657A9.772,9.772,0,0,1,16.464,25.16ZM10.442,11.721v4.035a8.833,8.833,0,0,0,5.923,8.388l.1.029.1-.029a8.833,8.833,0,0,0,5.923-8.388V11.721L16.464,9.047Z'
            transform='translate(-0.464 -0.57)'
          />
          <g id='Group_13694' data-name='Group 13694' transform='translate(15.273 12.364)'>
            <rect id='Rectangle_1658' data-name='Rectangle 1658' className='cls-2' width='1.455' height='1.455' />
            <rect
              id='Rectangle_1659'
              data-name='Rectangle 1659'
              className='cls-2'
              width='1.455'
              height='4.364'
              transform='translate(0 2.909)'
            />
          </g>
        </g>
      </g>
    </StyledTermsConditions>
  );
};

export default TermsConditionsIcon;
